import { api } from './api';

export const memoAPI = {
    // 메모 목록 조회
    getAll: (params = {}) => {
        return api.get('/memos', { params });
    },

    // 특정 계약의 메모 목록 조회
    getByTransaction: (transactionId) => {
        return api.get(`/memos/transaction/${transactionId}`);
    },

    // 메모 상세 조회
    getById: (id) => {
        return api.get(`/memos/${id}`);
    },

    // 메모 생성
    create: (data) => {
        return api.post('/memos', data);
    },

    // 메모 수정
    update: (id, data) => {
        return api.put(`/memos/${id}`, data);
    },

    // 메모 삭제
    delete: (id) => {
        return api.delete(`/memos/${id}`);
    },

    // 메모 통계
    getStatistics: () => {
        return api.get('/memos/statistics/overview');
    }
}; 